import React, { useMemo } from "react";
import { theme } from "uikit";

import { Order } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const OrderTimeCellContent: React.FC<OrderTimeCellContent.Props> = ({
	item,
}) => {
	const { dateFns } = useAppContext();

	const timezoneName = useTypedSelector(
		(state) => state.applicationConfig.timezone.name,
	);

	const isPreliminary = useMemo(
		() =>
			item.isPreliminary ||
			item?.additionalFields?.transfer?.lastReceivedOrder?.isPreliminary,
		[
			item?.additionalFields?.transfer?.lastReceivedOrder?.isPreliminary,
			item.isPreliminary,
		],
	);

	const content = useMemo(
		() =>
			isPreliminary
				? dateFns.formatTime2(item.orderDate, "HH:mm:ss", {
						timezone: timezoneName,
						zeroSeconds: true,
				  })
				: "",
		[dateFns, isPreliminary, item.orderDate, timezoneName],
	);

	const backgroundColor = useMemo(
		() => (isPreliminary ? "#7B0078" : undefined),
		[isPreliminary],
	);

	const textColor = useMemo(
		() => (isPreliminary ? theme.colors.white : undefined),
		[isPreliminary],
	);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			textColor={textColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace OrderTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default OrderTimeCellContent;
